import styled from "styled-components";

export const Contanier = styled.div`
width: 100%;
height: 100vh;
display: flex ;
position: fixed;
justify-content: center;
flex-direction: column;
color: white;
align-items: center ;
background: rgb(0,0,0 , 0.8);
z-index: 10;
overflow: hidden;
overflow-y: hidden;
`;

export const ImgLoader = styled.img`
width: 70px;
z-index: 10;

`;

export const Title = styled.div`
z-index: 10;
color: white;
opacity: 1;
`;